"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractInitializer_1 = __importDefault(require("../AbstractInitializer"));
const arrayMaker_1 = __importDefault(require("../../../../Util/arrayMaker"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
const getMealsNumIterator_1 = __importDefault(require("../Maker/getMealsNumIterator"));
const getCalorieBudgetIterator_1 = __importDefault(require("../Maker/getCalorieBudgetIterator"));
class NutritionInitializer extends AbstractInitializer_1.default {
    constructor(cache, nutritionModel, userRepository, customerRepository, dateTimeProvider, dateTimeModifier, dayTypeRepository, nutritionMaker) {
        super("nutrition_initializer", cache);
        this.initialize = async () => {
            const nutritionValues = {};
            const currentDate = this.dateTimeProvider.currentDate();
            const allCustomers = await this.customerRepository.getCustomers();
            const mealsNumIterator = (0, getMealsNumIterator_1.default)();
            const calorieBudgetIterator = (0, getCalorieBudgetIterator_1.default)();
            await (0, asyncIterate_1.default)(await this.userRepository.all(), async (user) => {
                await (0, asyncIterate_1.default)(allCustomers, async (customer, customerIndex) => {
                    const daysDiff = Math.abs(this.dateTimeModifier.daysDiff(customer.subscriptionPeriod.startDate, currentDate)) + 1;
                    const customerDayTypes = await this.dayTypeRepository.getDayTypes(customer.id);
                    nutritionValues[user.id + "/" + customer.subscriptionPeriod.periodId] =
                        (0, arrayMaker_1.default)(daysDiff, (index) => {
                            let method = customerIndex % 2 === 0 ? "caloriecount" : "handpalm";
                            // five days ago mixed day seems useful
                            if (index === daysDiff - 5) {
                                method = "mixed";
                            }
                            const date = this.dateTimeProvider.fromDateTimeToDate(this.dateTimeModifier.modifyDays(customer.subscriptionPeriod.startDate, index));
                            return this.nutritionMaker.createDay(method, date, mealsNumIterator.next(), customerDayTypes[date], ["caloriecount", "mixed"].includes(method)
                                ? calorieBudgetIterator.next()
                                : undefined);
                        });
                });
            });
            await this.nutritionModel.set(nutritionValues);
        };
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.userRepository = userRepository;
        this.customerRepository = customerRepository;
        this.nutritionModel = nutritionModel;
        this.dayTypeRepository = dayTypeRepository;
        this.nutritionMaker = nutritionMaker;
    }
}
exports.default = NutritionInitializer;
//# sourceMappingURL=NutritionInitializer.js.map